import { guideSteps } from '@/mocks/content';

export default function GuideSection() {
  return (
    <section id="guide" className="scroll-mt-nav py-12 md:py-16 bg-background-100/60">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="text-center max-w-2xl mx-auto">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 flex items-center justify-center gap-2">
              <i className="ri-guide-line text-accent-500"></i>
              浏览指南
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              四步就能从「完全不知道看什么」走到「已经有了一份自己的清单」。
            </p>
          </div>

          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {guideSteps.map((step, index) => (
              <div
                key={step.title}
                className="relative p-5 rounded-lg bg-background-50 border border-background-200"
              >
                <span className="absolute top-4 right-5 font-heading text-3xl font-bold text-background-300">
                  0{index + 1}
                </span>
                <span className="w-12 h-12 flex items-center justify-center rounded-md bg-accent-100 text-accent-700">
                  <i className={`${step.icon} text-xl`}></i>
                </span>
                <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{step.title}</h3>
                <p className="mt-2 text-xs leading-relaxed text-foreground-600">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}